module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("Eloise Bruce is a mother of two, living in Hampshire in the UK. She had a long career as a primary school teacher and has been working in social and therapeutic horticulture for the past 5 years. Eloise is passionate about getting children learning outdoors and helping them to develop their social and emotional skills through a strong connection with nature. In her spare time, Eloise can be found pottering around in the garden, watching the birds and squirrels through the window or wandering about in the woods.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "Graphic",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer004"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "Copyright ParaOverride-2",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Copyright © Eloise Bruce 2024")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("The right of ")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("Eloise Bruce ")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("to be identified as author of this work has been asserted by the author in accordance with sections 77 and 78 of the Copyright, Designs and Patents Act 1988.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("A CIP catalogue record for this title is available from the British Library.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("ISBN 9781398495401 (Paperback)")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("ISBN 9781398495418 (ePub e-book)")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("www.austinmacauley.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("First Published 2024")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("Austin Macauley Publishers Ltd® ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("1 Canada Square")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("Canary Wharf")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("London")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("E14 5AA")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "Author-bio",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("To nature and all it teaches us")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('p', {
    staticClass: "Graphic",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB7.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer009"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer011"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB3.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer013"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer014"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB4.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer015"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB5.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer016"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer017"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB6.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer018"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer019"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB8.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer020"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer021"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB9.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer022"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer023"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB10.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer024"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer025"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB11.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer026"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer027"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB12.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer028"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer029"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB13.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer030"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer031"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB14.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer032"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer033"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB15.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer034"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer035"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB16.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer036"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer037"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB17.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer038"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer039"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB18.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer040"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer041"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB19.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer042"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer043"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB20.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer044"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer045"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB21.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer046"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer047"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB22.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer048"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer049"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB23.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer050"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer051"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB24.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer052"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer053"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB25.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer054"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer055"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB26.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer056"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer057"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB27.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer058"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer059"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB28.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer060"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer061"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB29.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer062"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer063"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB30.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer064"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer065"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB31.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer066"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer067"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB32.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer068"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer069"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB33.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer070"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer071"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB34.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer072"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer073"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB35.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer074"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer075"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer076"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB36.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer077"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer078"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB37.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer079"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer080"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB38.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer081"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer082"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB39.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer083"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer084"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB40.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer085"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer086"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB41.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer087"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer088"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB42.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer089"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer090"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB43.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer091"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer092"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB44.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer093"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer094"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB45.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer095"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer096"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB46.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer097"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer098"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB47.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer099"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer100"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB48.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer101"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer102"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB49.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer103"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer104"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB50.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer105"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer106"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB51.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer107"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer108"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB52.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer109"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer110"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB53.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer111"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer112"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB54.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer113"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer114"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB55.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer115"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer116"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB56.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer117"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer118"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB57.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer119"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer120"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB58.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer121"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer122"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB59.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer123"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer124"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB60.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer125"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer126"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB61.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer127"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer128"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB62.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer129"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer130"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB63.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer131"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer132"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB64.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer133"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer134"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB65.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer135"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer136"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB66.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer137"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer138"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB67.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer139"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer140"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB68.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer141"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer142"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB69.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer143"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer144"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB70.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer145"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer146"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB71.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer147"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer148"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB72.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer149"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer150"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB73.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer151"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer152"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB74.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer153"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer154"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB75.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer155"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer156"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB76.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer157"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer158"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB77.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer159"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB78.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer160"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer161"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB79.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer162"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer163"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB80.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer164"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer165"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB81.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer166"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer167"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB82.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer168"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer169"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB83.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer170"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer171"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB84.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer172"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer173"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB85.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer174"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer175"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781398495401_EPUB86.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer176"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74a2456e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/New_EPUB.vue
// module id = 57
// module chunks = 0